<mat-card appearance="outlined" *ngIf="!!dynamicContent">
  <h2>Slides</h2>

  <div class="main-actions">
    <button (click)="addSlide()" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.addSlide' | translate }}</button>
  </div>

  <div class="action-header" [ngClass]="{ active: !!getSelectionCount() }">
    <div
      class="count">{{ getSelectionCount() }} {{ 'general.selectedEntries' + (getSelectionCount() > 1 ? 'Multi' : 'Single') | translate }}
    </div>

    <mat-form-field *ngIf="checkBoxActions">
      <mat-select [disabled]="!getSelectionCount()" [placeholder]="'general.selectionActions' | translate">
        <mat-option (click)="action.action()" *ngFor="let action of checkBoxActions">
          <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
          {{ action.translation | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="table-header">
    <ibex-checkbox #checkboxAll [id]="'checkboxAll'" (click)="selectItemsAll()"></ibex-checkbox>
    <div class="preview"></div>
    <div class="duration">{{ 'dynamicContent.screensaverDuration' | translate }}</div>
    <div class="additional">{{ 'general.title' | translate }}</div>
    <div class="drag">
      <mat-icon>keyboard_arrow_up</mat-icon>
      <mat-icon>keyboard_arrow_down</mat-icon>
    </div>
    <div class="actions"></div>
  </div>

  <div (cdkDropListDropped)="dropItem($event)" cdkDropList class="table" *ngIf="dynamicContent.lang === lang && dynamicContent.content.slides">
    <div *ngFor="let slide of dynamicContent.content.slides; let i = index" cdkDrag cdkDragBoundary=".menu-item-list" class="table-row">
      <div *cdkDragPlaceholder class="drag-placeholder"></div>
      <ibex-checkbox (click)="selectItem(i)"></ibex-checkbox>
      <div class="preview" (mouseenter)="hover(slide, $event)" (mouseleave)="leave()">
        <smart-image *ngIf="slide.type === 'image'" [url]="imageAssetPath + slide.value + '/' + 'oneToOne'" class="image"
                     (mouseenter)="hover(slide, $event)" (mouseleave)="leave()"></smart-image>
        <div class="video" *ngIf="slide.type === 'video'">
          <ibex-icon variant="blank" name="play"></ibex-icon>
        </div>
        <div class="iframe" *ngIf="slide.type === 'website'">
          <ibex-icon name="globe" variant="blank"></ibex-icon>
        </div>
      </div>
      <div class="duration">{{ slide.duration }} {{ 'general.seconds' | translate }}</div>
      <div class="additional">
        <ng-container *ngIf="slide.type === 'website'">{{slide.value}}</ng-container>
        <ng-container *ngIf="slide.type !== 'website'">{{assetsByPath[slide.value]?.title || assetsByPath[slide.value]?.originalFileName}}</ng-container>
      </div>
      <div class="drag">
        <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
          <mat-icon>drag_indicator</mat-icon>
        </button>
      </div>
      <div class="actions">
        <button (click)="editSlide(i)" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
        <button (click)="removeSlide(i)" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div (cdkDropListDropped)="dropItem($event)" cdkDropList class="table" *ngIf="isTranslation && translationEntries[lang].content.slides">
    <div *ngFor="let slide of translationEntries[lang].content.slides; let i = index" cdkDrag cdkDragBoundary=".menu-item-list" class="table-row">
      <div *cdkDragPlaceholder class="drag-placeholder"></div>
      <ibex-checkbox (click)="selectItem(slide)"></ibex-checkbox>
      <div class="preview">
        <smart-image *ngIf="slide.type === 'image'" [url]="imageAssetPath + slide.value + '/' + 'oneToOne'" class="image"></smart-image>
        <div class="video" *ngIf="slide.type === 'video'">
          <ibex-icon variant="blank" name="play"></ibex-icon>
        </div>
        <div class="iframe" *ngIf="slide.type === 'website'">
          <ibex-icon name="globe" variant="blank"></ibex-icon>
        </div>
      </div>
      <div class="title">{{ slide.duration }} {{ 'general.seconds' | translate }}</div>
      <div class="additional" *ngIf="slide.type === 'website'">{{slide.value}}</div>
      <div class="drag">
        <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
          <mat-icon>drag_indicator</mat-icon>
        </button>
      </div>
      <div class="actions">
        <button (click)="removeSlide(i)" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-card>

